import React, { Component } from "react";
import { Container, Row, Col, Card, CardHeader, CardBody, FormSelect, FormInput, FormGroup, Button, ButtonGroup,
  InputGroupAddon, InputGroupText,
  InputGroup} from "shards-react";
import DataTable from 'react-data-table-component';
import Modal from 'react-bootstrap/Modal'

import RangeDatePicker from "../components/common/RangeDatePicker";
import PageTitle from "../components/common/PageTitle";
import EfectoresList from "../components/efectores/efectores-list";
import EfectoresModalSearch from "../components/efectores/efectores-modal";
import { Store } from "../flux";

const columns = [
  {
    name: 'Módulo',
    selector: 'det',
    sortable: true,
  },
  {
    name: 'Práctica Médica',
    selector: 'descripcion',
    sortable: true,
  },
  {
    name: 'Fecha Desde',
    selector: 'fecha_desde',
    sortable:true,
  },
  {
    name: 'Fecha Hasta',
    selector: 'fecha_hasta',
    sortable:true,
  },
  {
    name: 'Cant.',
    selector: 'cantidad',
    sortable:true,
  },
  {
    name: 'Frecuencia',
    selector: 'frecuencia',
    sortable:true,
  }
];

const paginationOptions = { rowsPerPageText: 'Registros por página', rangeSeparatorText: 'de' };

class DetalleInternacionPage extends Component {
  constructor(props) {
    super(props);

    const internaciones = Store.getAsociados()

    this.state = {
      show_add_efector: false,
      internaciones: internaciones,
      current_item: null,
    }

    this.handleCloseAddEfector = this.handleCloseAddEfector.bind(this);
    this.handleShowAddEfector = this.handleShowAddEfector.bind(this);
    this.handleAddEfector = this.handleAddEfector.bind(this);
    this.handleRemoveEfector = this.handleRemoveEfector.bind(this);


  }

  handleCloseAddEfector () {
    this.setState({
      show_add_efector: false,
      current_item: null
    });
   }
  handleShowAddEfector (id) {
    
    this.setState({
      show_add_efector: true,
      current_item: id
    });
  }

  handleAddEfector(eflector){
    let { internaciones, current_item } = this.state
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    today = dd  + '/' +  mm + '/' + yyyy;
    const _internaciones =   internaciones.map((item, idx) => {

      if ( item.det === current_item ){
        item.efectores.push({
          ...eflector,
          fecha_desde: today
        })
      }
      else{
        item.practicas = item.practicas.map( practica => {
          if ( practica.det === current_item ){
            practica.efectores.push({
              ...eflector,
              fecha_desde: today
            })
          }

          return  practica
        })

      }
      return item
    })

    this.handleCloseAddEfector()
  }

  handleRemoveEfector(efector_id, parent_id){
    const { internaciones } = this.state

    const _internaciones =   internaciones.map((item, idx) => {

      if ( item.det === parent_id ){

          let efectores = []
          item.efectores.map( efector => {
            if ( efector.det !== parent_id && efector_id !== efector.id ) {
                efectores.push(efector)
            }
          })
          item.efectores = efectores
      }



      item.practicas.map( practica => {
        if ( practica.det === parent_id ){

          let efectores = []
          practica.efectores.map( efector => {
            if ( efector_id !== efector.id )
              efectores.push(efector)
          })

          practica.efectores = efectores
        }
        return  practica
      })

      return item
    })

    this.setState({
      internaciones: _internaciones
    });
    //console.log(efector_id, parent_id, _internaciones)
  }

  render() {
    const { internaciones, show_add_efector, efectores } = this.state
    const { match, navigateToPath } = this.props

    const data =   internaciones.find( internacion => Number(match.params.id) === internacion.pedido )

    let data_table = [data, ...data.practicas];

    return(
      <Container fluid className="main-content-container px-4">
          {/* Page Header */}
          <Row noGutters className="page-header pt-3">
            <PageTitle sm="4" title={ "Detalle Orden de Internación Nº " + match.params.id } subtitle="" className="text-sm-left" />
          </Row>

          <EfectoresModalSearch show={show_add_efector} handleClose={this.handleCloseAddEfector} handleAdd={this.handleAddEfector} />

          {/* Default Light Table */}

                <Row className="py-3 mb-4">
                  <Col >
                  <Container fluid className="px-3 pt-2 border-top bg-celeste detalle-header" >
                    <Row >

                  <Col className="col-md-3">
                    <Row>
                      <Col className="col-md-12">
                        <label className="mb-0">Apellido y Nombre</label>
                        <h6><b>{data.apellido} {data.nombre}</b></h6>
                      </Col>
                      <Col className="col-md-5">
                        <label className="mb-0">Nro. Asociado</label>
                        <h6>{data.nro_asociado}</h6>
                      </Col>
                      <Col className="col-md-5">
                        <label className="mb-0">Plan</label>
                        <h6>{data.plan}</h6>
                      </Col>
                    </Row>
                  </Col>
                  <Col className="col-md-4">
                    <label className="mb-0">Domicilio</label>
                    <h6 className="mb-0">{data.direccion}</h6>
                    <h6 className="mb-0">C.P.: {data.cp} - {data.localidad} - {data.provincia}</h6>
                    <h6>agregar data de tel</h6>
                  </Col>
                  <Col className="col-md-5">
                    <label className="mb-0">Estado</label>
                    <h6>{data.estado}</h6>
                    <label className="mb-0">Descripción del Diagnóstico</label>
                    <h6>{data.diagnostico}</h6>
                  </Col>

                    </Row>
                    </Container>
                  </Col>
                </Row>


                <Row>
                  <Col className="col-md-9">
                    <div className="d-flex">
                      <h6><b>Practicas Domiciliarias</b></h6>
                      <FormGroup className="col-md-3">
                        <RangeDatePicker/>
                      </FormGroup>
                      <FormGroup className="col-md-2">
                        <FormSelect size="sm">
                          <option value="">Frecuencia</option>
                          <option value="1">SEMANAL</option>
                          <option value="2">DIARIA</option>

                        </FormSelect>
                      </FormGroup>
                      <ButtonGroup size="sm" className="col-md-3 d-table">
                        <Button> Filtrar </Button>
                        <Button  outline theme="secondary" className="mx-auto"> Limpiar </Button>
                      </ButtonGroup>
                    </div>
                  </Col>
                  <Col className="col-md-3">

                  <InputGroup>
                    <FormInput placeholder="Buscar" />
                    <InputGroupAddon type="append">
                      <Button><i className="material-icons">search</i></Button>
                    </InputGroupAddon>
                  </InputGroup>
                </Col>
              </Row>
                <DataTable
                  noHeader={true}
                  columns={columns}
                  data={data_table}
                  expandableRows
                  expandableRowsComponent={<EfectoresList handleShow={this.handleShowAddEfector} navigateToPath={navigateToPath} handleRemove={this.handleRemoveEfector} efectores={efectores} />}

                />
        </Container>
    )
  }
}
export default DetalleInternacionPage;
